export default __webpack_public_path__ + "static/media/psu-stidti-italic.4e37577b.ttf";